import type { $Fetch } from 'ofetch';
import type { MetaVendas, MetaVendasCommand, MetaEscopo } from '@/domain/model/MetaVendas';
import type { Page } from '@/domain/model/Page';
import type { MetaVendasGateway } from '@/application/port/out/MetaVendasGateway';
import type { ApiResponse, SpringPage } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/metas-vendas';

export class HttpMetaVendasGateway implements MetaVendasGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: { escopo?: MetaEscopo; ativo?: boolean; page?: number; size?: number }): Promise<Page<MetaVendas>> {
    const params: Record<string, string | number | boolean> = {};
    if (p.escopo) params['escopo'] = p.escopo;
    if (typeof p.ativo === 'boolean') params['ativo'] = p.ativo;
    if (typeof p.page === 'number') params['page'] = p.page;
    if (typeof p.size === 'number') params['size'] = p.size;
    const res = await this.client<ApiResponse<SpringPage<MetaVendas>>>(PATH, { method: 'GET', params });
    assertApiSuccess(res);
    const d = res.data;
    return { content: d.content, number: d.number, size: d.size, totalElements: d.totalElements, totalPages: d.totalPages, first: d.first, last: d.last };
  }

  async get(id: string): Promise<MetaVendas> {
    const res = await this.client<ApiResponse<MetaVendas>>(`${PATH}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async criar(command: MetaVendasCommand): Promise<MetaVendas> {
    const res = await this.client<ApiResponse<MetaVendas>>(PATH, { method: 'POST', body: command });
    assertApiSuccess(res);
    return res.data;
  }

  async atualizar(id: string, command: MetaVendasCommand): Promise<MetaVendas> {
    const res = await this.client<ApiResponse<MetaVendas>>(
      `${PATH}/${encodeURIComponent(id)}`, { method: 'PUT', body: command },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async desativar(id: string): Promise<void> {
    await this.client<null>(`${PATH}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
}
